/* eslint-disable */
import Vue from 'vue'
import MainService from '@/services/MainService'
import CallService from '@/services/Call'

class FileUpload {
  file:any

  async uploadSessionFile (file: any, sessionId: Number) {
    const data = {
      route: `ocular/widget/v2/sessions/${sessionId}/file-upload`,
      params: <any> {}
    }

    if (!Array.isArray(file)) {
      data.params['file'] = file
    }

    if (Array.isArray(file)) {
      data.params['files'] = file
    }

    return new Promise((resolve, reject) => {
      MainService.formPost(data)
        .then((response) => {
          const res = response.data
          resolve(res)
        })
        .catch((e) => {
          console.log(e)
          reject(e)
        })
        .then(() => {})
      })
  }

  fileType (base64: String) {
    let type

    if (base64.indexOf('image/') !== -1) {
      type = 'image'
    } else if (base64.indexOf('video/') !== -1) {
      type = 'video'
    } else if (base64.indexOf('audio/') !== -1) {
      type = 'audio'
    } else {
      type = 'application'
    }

    return type
  }

  async handleFileClick(element: HTMLElement, url: string) {
    const baseUrl: string = `${process.env.VUE_APP_AWS_S3_URL}/`
    const filePath = url.replace(baseUrl, '')

    element.style.pointerEvents = 'none'
    element.innerHTML = '<small>Descargando...<small>'

    CallService.sessionChatPresignedUrl(filePath)
      .then((response: any) => {
        const url = response.data
        window.open(url, '_blank')
      })
      .finally(() => {
        element.style.pointerEvents = 'auto'
        element.innerHTML = '<small>Ver archivo<small>'
      })
  }

  chatFileLinkGenerator (element: HTMLElement): void {
    const fileLink: HTMLElement | null = element.querySelector('a#chat-file-link')

    if (!fileLink) {
      return
    }

    fileLink.addEventListener('click', (event) => {
      event.preventDefault()

      const url = fileLink.getAttribute('href');

      if (!url) {
        return;
      }

      this.handleFileClick(fileLink, url)
    })
  }
}

const fileUpload = new FileUpload()
Vue.prototype.$fileUpload = fileUpload
export default fileUpload
